import React from "react";
import { useAuthActions } from "../hooks/useAuthActions";
import { Button } from "./ui/button";

export default function SignOutButton({ size = "default" }) {
  const { signout } = useAuthActions();

  return (
    <Button size={size} variant="outline" className="px-3 py-1 ml-2" onClick={signout}>
      Sign Out
    </Button>
  );
} 